import { useEffect, useState } from "react";
import Reveal from "@/components/Reveal";

const TARGET = new Date("2026-11-24T16:00:00+05:30").getTime();

const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

export default function Countdown() {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, []);

    const diff = Math.max(0, TARGET - now);
    const units = [
        { label: "days", value: pad(Math.floor(diff / 86400000)), id: "days" },
        { label: "hours", value: pad(Math.floor((diff / 3600000) % 24)), id: "hours" },
        { label: "minutes", value: pad(Math.floor((diff / 60000) % 60)), id: "minutes" },
        { label: "seconds", value: pad(Math.floor((diff / 1000) % 60)), id: "seconds" },
    ];

    return (
        <section data-testid="countdown-section" className="mx-auto max-w-5xl px-6 py-20 text-center sm:py-24">
            <Reveal>
                <p className="eyebrow">The big moment</p>
                <h2 className="font-display mt-3 text-3xl tracking-tight sm:text-4xl" style={{ color: "var(--ink)" }}>
                    Paanigrahan <span className="italic" style={{ color: "var(--wine)" }}>Sanskar</span>
                </h2>
                <p className="mt-3 text-sm sm:text-base" style={{ color: "var(--muted)" }}>
                    24 November 2026 · 4:00 PM · Bera Hambro Ki Bawri
                </p>
            </Reveal>

            <div className="mt-10 flex items-stretch justify-center gap-3 sm:gap-6">
                {units.map((u, i) => (
                    <Reveal key={u.id} delay={0.1 + i * 0.08}>
                        <div
                            data-testid={`countdown-${u.id}`}
                            className="gold-ring flex w-[70px] flex-col items-center rounded-2xl px-2 py-4 sm:w-28 sm:py-6"
                            style={{ background: "rgba(255,253,250,0.85)" }}
                        >
                            <span className="font-display text-3xl sm:text-5xl" style={{ color: "var(--wine)" }}>
                                {u.value}
                            </span>
                            <span className="mt-1 text-[0.6rem] uppercase tracking-[0.25em] sm:text-xs" style={{ color: "var(--muted)" }}>
                                {u.label}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
